// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-popup-content {
  --g-tabs-item-gap: 16px;
  --g-tabs-item-border-width: 2px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 600px;
}
.dl-datepicker-popup-content__tabs {
  flex: 0 0 40px;
  padding-left: 16px;
}
.dl-datepicker-popup-content__tabs .g-tab-list {
  box-shadow: none;
}
.dl-datepicker_mobile .dl-datepicker-popup-content__tabs {
  padding-left: 0;
}
.dl-datepicker_mobile .dl-datepicker-popup-content__tabs .g-tab-list {
  justify-content: center;
}
.dl-datepicker-popup-content__calendar-container {
  flex: 1 1 auto;
  overflow-y: auto;
}
.dl-datepicker-popup-content__apply-btn {
  flex: 0 0 40px;
  padding: 2px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/PopupContent/PopupContent.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,+BAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AAAJ;AAEI;EACI,cAAA;EACA,kBAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ;AAGQ;EACI,eAAA;AADZ;AAGY;EACI,uBAAA;AADhB;AAMI;EACI,cAAA;EACA,gBAAA;AAJR;AAOI;EACI,cAAA;EACA,YAAA;AALR","sourcesContent":[".dl-datepicker-popup-content {\n  --g-tabs-item-gap: 16px;\n  --g-tabs-item-border-width: 2px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 600px;\n}\n.dl-datepicker-popup-content__tabs {\n  flex: 0 0 40px;\n  padding-left: 16px;\n}\n.dl-datepicker-popup-content__tabs .g-tab-list {\n  box-shadow: none;\n}\n.dl-datepicker_mobile .dl-datepicker-popup-content__tabs {\n  padding-left: 0;\n}\n.dl-datepicker_mobile .dl-datepicker-popup-content__tabs .g-tab-list {\n  justify-content: center;\n}\n.dl-datepicker-popup-content__calendar-container {\n  flex: 1 1 auto;\n  overflow-y: auto;\n}\n.dl-datepicker-popup-content__apply-btn {\n  flex: 0 0 40px;\n  padding: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
